module.exports = __webpack_public_path__ + "img/image23.cd771713.png";